import hexRgb from 'hex-rgb';
import type { GlobalToken } from 'antd';

// Based on https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color
const getTextColorForBackground = (
  backgroundColorAsHex: string,
  themeToken: GlobalToken,
): GlobalToken['colorWhite'] | undefined => {
  const rgb = hexRgb(backgroundColorAsHex);

  if (!rgb) {
    return undefined;
  }

  const color =
    rgb.red * 0.299 + rgb.green * 0.587 + rgb.blue * 0.114 > 186
      ? themeToken.colorTextSecondary
      : themeToken.colorWhite;
  return color;
};

export default getTextColorForBackground;
